module.exports = __webpack_public_path__ + "static/media/modelos.ff8e73ba.svg";